import { render } from "./UpdateCustomerReferenceForm.vue?vue&type=template&id=2bef594b&scoped=true"
import script from "./UpdateCustomerReferenceForm.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerReferenceForm.vue?vue&type=script&lang=js"

import "./UpdateCustomerReferenceForm.vue?vue&type=style&index=0&id=2bef594b&scoped=true&lang=postcss"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bef594b"]])

export default __exports__